class UsersApiResponseModel {
  // #region Props
  idUsuario;
  RolNombre;
  nombre;
  apellido1;
  apellido2;
  Apellidos;
  email;
  Afiliacion;
  activo;
  RolSoporteId;
  label;
  unidad;
  Informes;
  numInformes;
  UltimaConexion;
  Grupos;
  esAdministrador;
  rol;
  idGrupo;
  habilitadoHasta;
  // #endregion

  constructor(object) {
    // Assign props to this object instance
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        this[key] = element;

        if (key == "idUser") {
          this.idUsuario = element;
        }
      }
    }
  }

  // #region Private methods
  // #endregion
}

export default UsersApiResponseModel;
